import React, { useEffect, useState } from 'react';
import { FilterChoice } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FilterChoice';
import SearchHotelsFilterInput from '@app/model/flexi_sets/input/SearchHotelsFilterInput';
import _isEmpty from 'lodash/isEmpty';
import FlexiSetFilterWrapper
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetFilterWrapper';
import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';

export type FlexiSetGenericBooleanFilterFilterConfig = {
	title: string;
	choice: FilterChoice<boolean>;
	getHotelValue: (hotel: SearchHotelWithinRadiusResult) => boolean | undefined;
	addToFilter: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => void;
	removeFromFilter: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => void;
	isChoiceSelected: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => boolean;
};

const FlexiSetGenericBooleanFilterFragment: React.FunctionComponent<{
	areaHotels: SearchHotelWithinRadiusResult[],
	filter: SearchHotelsFilterInput,
	onFilter: (filter: SearchHotelsFilterInput) => void,
	config: FlexiSetGenericBooleanFilterFilterConfig
}> = ({ areaHotels, filter, onFilter, config }) => {

	const [choice, setChoice] = useState<FilterChoice<boolean>>(config.choice);

	useEffect(() => {
		const _choice = { ...choice };
		_choice.count = 0;
		if (!_isEmpty(areaHotels)) {
			areaHotels.forEach(hotel => {
				const value = config.getHotelValue(hotel);
				if (!!value && value) _choice.count++;
			});
		}
		setChoice(_choice);
	}, [areaHotels, config]);

	const onChecked = (e: React.ChangeEvent<HTMLInputElement>, choice: FilterChoice<boolean>) => {
		if (e.target.checked) {
			config.addToFilter(filter, choice);
		} else {
			config.removeFromFilter(filter, choice);
		}
		onFilter(filter);
	};

	return !!choice && <FlexiSetFilterWrapper title={config.title}>
		<div className="flex items-center gap-x-2">
			<input
				type="checkbox"
				id={`checkbox_${config.title}_${choice.value}`}
				onChange={(e) => onChecked(e, choice)}
				className="input-checkbox cursor-pointer"
				checked={config.isChoiceSelected(filter, choice)}
			/>
			<label
				htmlFor={`checkbox_${config.title}_${choice.value}`}
				className="block text-sm font-normal leading-6 text-gray-700 cursor-pointer"
			>
				{choice.name}
			</label>
			<span
				className="inline-flex items-center rounded-md bg-slate-100 px-1.5 py-0.5 text-xs font-medium text-slate-700">
						{choice.count}
					</span>
		</div>
	</FlexiSetFilterWrapper>;
};

export default FlexiSetGenericBooleanFilterFragment;
